import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { errMsg, homeFor } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { AuthShell, GoogleButton } from "@/components/AuthParts";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const user = await login(form.email, form.password);
      toast.success(`Selamat datang kembali, ${user.name}`);
      navigate(params.get("next") || homeFor(user), { replace: true });
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Masuk ke Tuntas" subtitle="Kelola permintaan, penawaran, dan percakapan Anda.">
      <GoogleButton />
      <div className="my-6 flex items-center gap-3 text-xs text-stone-400">
        <span className="h-px flex-1 bg-stone-200" /> atau dengan email <span className="h-px flex-1 bg-stone-200" />
      </div>
      <form onSubmit={submit} className="space-y-4" data-testid="login-form">
        <div className="space-y-2">
          <Label htmlFor="email">Email</Label>
          <Input id="email" type="email" required value={form.email} data-testid="login-email-input"
            onChange={(e) => setForm({ ...form, email: e.target.value })} className="h-11 rounded-xl" placeholder="nama@email.com" />
        </div>
        <div className="space-y-2">
          <Label htmlFor="password">Kata sandi</Label>
          <Input id="password" type="password" required value={form.password} data-testid="login-password-input"
            onChange={(e) => setForm({ ...form, password: e.target.value })} className="h-11 rounded-xl" />
        </div>
        {error && <p className="rounded-xl bg-rose-50 px-4 py-3 text-sm text-rose-700" data-testid="login-error">{error}</p>}
        <Button type="submit" disabled={loading} data-testid="login-submit-button" className="h-11 w-full rounded-xl bg-teal-700 font-semibold hover:bg-teal-800">
          {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Masuk
        </Button>
      </form>
      <p className="mt-6 text-center text-sm text-stone-500">
        Belum punya akun?{" "}
        <Link to="/daftar" className="font-semibold text-teal-700 hover:underline" data-testid="login-to-register-link">Daftar gratis</Link>
      </p>
    </AuthShell>
  );
}
